// a singleton class that represents that context that the api's are running in.
// this is setup during bootstrap
export class ApiContext {
  private static _instance: ApiContext;
  private _isDesktop = false;
  private _isServer = false;
  private _isAuthoring = false;
  private _isVisible = true;
  private _isPublic = false;
  private _isSaas = false;
  private _isPlatformOfficialRelease = false;
  private _externalApiVersion = '';
  private _isFirstClass = false;
  private constructor() {}

  public static getInstance(): ApiContext {
    if (!this._instance) {
      this._instance = new ApiContext();
    }
    return this._instance;
  }

  public isDesktop(): boolean {
    return this._isDesktop;
  }

  public setIsDesktop(isDesktop: boolean): void {
    this._isDesktop = isDesktop;
  }

  public isServer(): boolean {
    return this._isServer;
  }

  public setIsServer(isServer: boolean): void {
    this._isServer = isServer;
  }

  public isVisible(): boolean {
    return this._isVisible;
  }

  public setIsVisible(isVisible: boolean): void {
    this._isVisible = isVisible;
  }

  public isAuthoring(): boolean {
    return this._isAuthoring;
  }

  public isPublic(): boolean {
    return this._isPublic;
  }

  public isSaas(): boolean {
    return this._isSaas;
  }

  public isPlatformOfficialRelease(): boolean {
    return this._isPlatformOfficialRelease;
  }

  public setIsAuthoring(isAuthoring: boolean): void {
    this._isAuthoring = isAuthoring;
  }

  public setIsPublic(isPublic: boolean): void {
    this._isPublic = isPublic;
  }

  public setIsSaas(isSaas: boolean): void {
    this._isSaas = isSaas;
  }

  public setIsPlatformOfficialRelease(isPlatformOfficialRelease: boolean): void {
    this._isPlatformOfficialRelease = isPlatformOfficialRelease;
  }

  public getExternalApiVersion(): string {
    return this._externalApiVersion;
  }

  public setExternalApiVersion(externalApiVersion: string): void {
    this._externalApiVersion = externalApiVersion;
  }

  public isFirstClass(): boolean {
    return this._isFirstClass;
  }

  public setIsFirstClass(isFirstClass: boolean): void {
    this._isFirstClass = isFirstClass;
  }
}
